import React from "react";
import { useT } from "../i18n/I18nProvider";

const IMG = {
  i1: "https://customer-assets.emergentagent.com/job_colorful-imports/artifacts/7ccc1xrh_image.png",
  i2: "https://customer-assets.emergentagent.com/job_colorful-imports/artifacts/oklbny3c_image.png",
  i3: "https://customer-assets.emergentagent.com/job_colorful-imports/artifacts/u4pnwhqm_image.png",
  i4: "https://customer-assets.emergentagent.com/job_colorful-imports/artifacts/kuu2u7mf_image.png",
  i5: "https://customer-assets.emergentagent.com/job_colorful-imports/artifacts/rof1sx70_image.png",
};

const ITEMS = [
  { key: "i2", testid: "wall-hangings", img: IMG.i2 },
  { key: "i3", testid: "bird-baths", img: IMG.i3 },
  { key: "i4", testid: "medium-planters", img: IMG.i4 },
  { key: "i5", testid: "ceramic-art", img: IMG.i5 },
];

export default function Specials() {
  const { t } = useT();
  return (
    <section
      id="specials"
      data-testid="specials-section"
      className="py-20 md:py-28 bg-[#f5efde] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-[#b8420f] font-bold mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-[#b8420f] animate-pulse" />
              {t("specials.eyebrow")}
            </div>
            <h2 className="font-display font-black text-stone-900 text-[40px] md:text-[56px] leading-[1.02] tracking-tight">
              {t("specials.h_a")}{" "}
              <span className="font-script text-[#b8420f] text-[60px] md:text-[84px] leading-none">
                {t("specials.h_b")}
              </span>
            </h2>
            <p className="mt-4 text-stone-600 text-[16px] max-w-xl">{t("specials.sub")}</p>
          </div>
          <a
            href="tel:+18176561046"
            data-testid="specials-call-link"
            className="inline-flex items-center gap-2 rounded-full bg-[#14532d] hover:bg-[#0f3d21] text-white px-6 py-3 text-[14px] font-bold tracking-wide transition-colors"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.93.37 1.84.7 2.71a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.37-1.27a2 2 0 0 1 2.11-.45c.87.33 1.78.57 2.71.7A2 2 0 0 1 22 16.92z"/></svg>
            {t("specials.cta_call")}
          </a>
        </div>

        <article
          data-testid="special-card-outdoor-pottery"
          className="lift relative grid md:grid-cols-12 gap-0 bg-white rounded-[28px] overflow-hidden border border-stone-200 mb-6 md:mb-7"
        >
          <div className="md:col-span-7 relative aspect-[16/10] md:aspect-auto md:min-h-[400px] bg-stone-100">
            <img src={IMG.i1} alt={t("specials.i1_t")} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <div className="absolute top-5 left-5 inline-flex items-center gap-2 bg-[#b8420f] text-white px-4 py-2 rounded-full text-[13px] font-extrabold tracking-wide shadow-lg">
              <span className="font-script text-amber-200 text-lg leading-none">{t("specials.offer_badge")}</span>
              {t("specials.i1_d")}
            </div>
          </div>
          <div className="md:col-span-5 p-7 md:p-10 flex flex-col justify-center">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#14532d] font-bold mb-3">
              {t("specials.featured_label")}
            </div>
            <h3 className="font-display font-black text-stone-900 text-[34px] md:text-[44px] leading-[1.05] tracking-tight">
              {t("specials.i1_t")}
            </h3>
            <div className="mt-4 flex items-baseline gap-3">
              <div className="font-display font-black text-[#b8420f] text-[44px] md:text-[56px] leading-none">
                {t("specials.i1_d")}
              </div>
            </div>
            <p className="mt-4 text-stone-600 text-[16px] leading-relaxed">
              {t("specials.i1_b")}. {t("specials.featured_extra")}
            </p>
            <div className="mt-7 inline-flex items-center gap-2 text-[13px] font-semibold text-stone-500">
              <span className="w-2 h-2 rounded-full bg-[#14532d]" />
              {t("specials.featured_supplies")}
            </div>
          </div>
        </article>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {ITEMS.map((s, i) => (
            <article
              key={s.key}
              data-testid={`special-card-${s.testid}`}
              className="lift relative bg-white rounded-3xl overflow-hidden border border-stone-200 flex flex-col"
            >
              <div className="relative aspect-square bg-stone-100">
                <img src={s.img} alt={t(`specials.${s.key}_t`)} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                <div className="absolute top-3 left-3 bg-[#b8420f] text-white px-3 py-1.5 rounded-full text-[11px] font-extrabold tracking-wide shadow-md">
                  {t(`specials.${s.key}_d`)}
                </div>
                <div className="absolute top-3 right-3 bg-white/95 backdrop-blur text-stone-900 px-2.5 py-1 rounded-full text-[10px] font-bold tracking-wide">
                  #{i + 2}
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-display font-bold text-stone-900 text-[20px] leading-tight">
                  {t(`specials.${s.key}_t`)}
                </h3>
                <p className="mt-2 text-[13px] text-stone-600 leading-relaxed flex-1">
                  {t(`specials.${s.key}_b`)}
                </p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-bold text-[#14532d] uppercase tracking-wide">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#14532d]" />
                  {t("specials.in_store")}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center text-[13px] text-stone-500">
          {t("specials.footnote")}
        </div>
      </div>
    </section>
  );
}
